import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook that provides tenant-aware navigation.
 * All paths will be prefixed with the tenant slug if one is active.
 */
export function useTenantNavigation() {
  const navigate = useNavigate();
  const tenantSlug = sessionStorage.getItem("tenant_slug");
  const prefix = tenantSlug ? `/${tenantSlug}` : "";

  const tenantNavigate = useCallback((path, options) => {
    // If path already starts with the prefix, don't double-prefix
    const fullPath = path.startsWith(prefix) ? path : `${prefix}${path}`;
    navigate(fullPath, options);
  }, [navigate, prefix]);

  const getPath = useCallback((path) => {
    return path.startsWith(prefix) ? path : `${prefix}${path}`;
  }, [prefix]);

  return { navigate: tenantNavigate, getPath, prefix };
}

/**
 * Get the tenant prefix for use outside of components
 */
export function getTenantPrefix() {
  const tenantSlug = sessionStorage.getItem("tenant_slug");
  return tenantSlug ? `/${tenantSlug}` : "";
}
